import { CacheInterceptor } from './cache-interceptor/cache.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
export class CfInterceptorModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  declarations: [],
  entryComponents: [],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: CacheInterceptor,
    multi: true
  }],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfInterceptorModule_tsickle_Closure_declarations() {
/** @type {?} */
CfInterceptorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfInterceptorModule.ctorParameters;
}
;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
